import { motion } from 'framer-motion'
import { CheckCircle2, Phone } from 'lucide-react'
import { siteConfig } from '@/lib/utils'

const differentials = [
  'Equipe experiente que entrega o que promete',
  'Programa de capacitação — abrimos espaço pra júniors e recém-formados crescerem com a gente',
  'Processo enxuto, foco em valor — sem cerimônia inútil',
  'Suporte 24h quando o projeto exige',
]

export function About() {
  return (
    <section id="sobre" className="py-20 md:py-28">
      <div className="container grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-sm font-semibold tracking-wider text-brand-cyan uppercase mb-3">
            Sobre nós
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
            Tecnologia com excelência e foco no cliente
          </h2>
          <p className="mt-6 text-lg text-muted-foreground text-pretty">
            Acreditamos que o mundo digital requer soluções de valor. Trabalhamos como
            extensão do seu time, combinando engenharia sênior e um programa ativo de formação
            de novos talentos — porque acreditamos que dar oportunidade pra quem tá começando
            é parte do nosso papel.
          </p>

          <ul className="mt-8 space-y-3">
            {differentials.map((d) => (
              <li key={d} className="flex items-start gap-3 text-sm md:text-base">
                <CheckCircle2 className="size-5 text-brand-cyan shrink-0 mt-0.5" />
                <span>{d}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex items-center gap-4 p-4 rounded-lg border border-border/50 bg-card max-w-md">
            <div className="size-12 rounded-md bg-brand-blue/15 flex items-center justify-center shrink-0">
              <Phone className="size-5 text-brand-cyan" />
            </div>
            <div>
              <div className="text-xs text-muted-foreground">Fale com a gente</div>
              <a
                href={siteConfig.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg font-semibold text-brand-cyan hover:underline"
              >
                {siteConfig.phone}
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="relative aspect-[4/5] lg:aspect-[3/4] max-w-md mx-auto w-full"
        >
          <div className="absolute -inset-6 bg-brand-gradient opacity-30 rounded-2xl blur-3xl" aria-hidden />
          <img
            src="/img/about.jpg"
            alt="Equipe i3 Solutions"
            className="relative rounded-2xl shadow-2xl shadow-brand-purple/30 object-cover w-full h-full border border-border/50"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  )
}
